<template>
  <div v-loading="loading" class="order-details">
    <div class="box">
      <div class="title">顾客信息<span v-if="orderDeatilsData.phone" style="font-size: 14px;color: #FD5C8C;padding-left: 10px;cursor: pointer;" @click="customerDetails(orderDeatilsData.phone)">更多 <i class="el-icon-arrow-right"></i></span></div>
      <div class="memberInfo">
        <div v-if="!orderDeatilsData.cardNo" class="srcoll">
          <div class="i_one">
            <img :src="orderDeatilsData.headImgUrl ? (orderDeatilsData.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120') : 'static/images/head.png'" />
            <!-- <i class="iconfont" v-else>&#xe719;</i> -->
          </div>
          <div class="li">
            <!-- {{orderDeatilsData}} -->
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ orderDeatilsData.dtoList ? orderDeatilsData.dtoList.customerName ? orderDeatilsData.dtoList.customerName :'新增顾客' :orderDeatilsData.memberName ?orderDeatilsData.memberName : '新增顾客' }}</p>
              </div>
              <h5 @mouseover="tooltipStatus = Lib.textShow($event)">姓名：{{ orderDeatilsData.dtoList ? orderDeatilsData.dtoList.customerName ? orderDeatilsData.dtoList.customerName :'新增顾客' :orderDeatilsData.memberName ?orderDeatilsData.memberName : '新增顾客' }}</h5>
            </el-tooltip>
          </div>
          <div class="li">
            <h5>手机号码：{{ orderDeatilsData.dtoList ? orderDeatilsData.dtoList.customerPhone ? Lib.starPhone(orderDeatilsData.dtoList.customerPhone) : '--' : orderDeatilsData.phone ?Lib.starPhone(orderDeatilsData.phone) : '--' }}</h5>
          </div>
          <div class="payStatus">
            <img v-if="orderDeatilsData.dtoList" :src="roomImg(orderDeatilsData.dtoList.infoType)" />
            <img v-else :src="returnImg(orderDeatilsData)" />
            <!-- <p v-if="orderDeatilsData.phone" @click="customerDetails(orderDeatilsData.phone)">点击查看顾客详情</p> -->
          </div>
        </div>
        <div v-else class="srcoll">
          <div class="i_one">
            <img :src="orderDeatilsData.headImgUrl ? (orderDeatilsData.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120') : 'static/images/head.png'" />
            <!-- <i class="iconfont" v-else>&#xe719;</i> -->
          </div>
          <div class="li">
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ orderDeatilsData.memberName }}</p>
              </div>
              <h5 @mouseover="tooltipStatus = Lib.textShow($event)">
                <img v-if="orderDeatilsData.memberType == 1" src="@/assets/images/crown.png" />
                <img v-else-if="orderDeatilsData.memberType == 2" src="@/assets/images/plante.png" /> 姓名：{{ orderDeatilsData.memberName }}
              </h5>
            </el-tooltip>
          </div>
          <div class="li">
            <h5>手机号码：{{ Lib.starPhone(orderDeatilsData.phone) }}</h5>
          </div>
          <div class="li">
            <h5>会员卡号：{{ orderDeatilsData.cardNo }}</h5>
          </div>
          <div class="payStatus">
            <img v-if="orderDeatilsData.dtoList" :src="roomImg(orderDeatilsData.dtoList.infoType)" />
            <img v-else :src="returnImg(orderDeatilsData)" />
            <!-- <p v-if="orderDeatilsData.phone" @click="customerDetails(orderDeatilsData.phone)">点击查看顾客详情</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 预约订单 -->
    <div v-if="orderDeatilsData.bookOrderMsgDTO" class="box">
      <div class="title">预约信息</div>
      <div class="orderInfo">
        <h3>下单时间</h3>
        <h4>{{ orderDeatilsData.bookOrderMsgDTO.createTime }}</h4>
        <h3>预约日期</h3>
        <h5>{{ orderDeatilsData.bookOrderMsgDTO.bookDate || '--' }}</h5>
        <h3>预约时间</h3>
        <h5>{{ orderDeatilsData.bookOrderMsgDTO.startTime }}~{{ orderDeatilsData.bookOrderMsgDTO.endTime }}</h5>
        <h3>预约来源</h3>
        <h5>{{ orderDeatilsData.bookOrderMsgDTO.buySource == 0 ? '电脑端' : orderDeatilsData.bookOrderMsgDTO.buySource == 1 ? '粉丝端' : orderDeatilsData.bookOrderMsgDTO.buySource == 2 ? '店员APP' : 'Smartbox' }}</h5>
        <h3>预约项目</h3>
        <h5>{{ orderDeatilsData.bookOrderMsgDTO.itemName || '--' }}</h5>
        <h3>预约占用时长</h3>
        <h5>{{ Math.floor(orderDeatilsData.serviceTime / 60)+'小时'+orderDeatilsData.serviceTime % 60+'分' }}</h5>
        <h3>预约{{ Lib.collectively() }}</h3>
        <h5>{{ orderDeatilsData.bookOrderMsgDTO.technicianName || '到店安排' }}</h5>
        <h3>预约状态</h3>
        <h5>{{ Lib.getBespeakVal(orderDeatilsData.bookOrderMsgDTO.bookStatus,1) }}</h5>
        <h3 v-show="orderDeatilsData.bookOrderMsgDTO.bookStatus==-3">取消原因</h3>
        <h5 v-show="orderDeatilsData.bookOrderMsgDTO.bookStatus==-3">{{ orderDeatilsData.bookOrderMsgDTO.cancelCause || '--' }}</h5>
        <h3>预约备注</h3>
        <h5 :class="orderDeatilsData.bookOrderMsgDTO.bookStatus==-3 ? '' : 'remarks'" :style="orderDeatilsData.bookOrderMsgDTO.bookStatus==-3 ? 'width: 607px;' : ''">{{ orderDeatilsData.bookOrderMsgDTO.remark || '--' }}</h5>
      </div>
    </div>
    <div v-if="orderDeatilsData.distributorInfo || orderDeatilsData.distributionSuperiorInfo" class="box">
      <div class="title">分销员信息</div>
      <div class="orderInfo">
        <h3>分销员</h3>
        <h5>{{ orderDeatilsData.distributorInfo ? orderDeatilsData.distributorInfo.name : '--' }}</h5>
        <h3>分销员佣金</h3>
        <h5>￥{{ orderDeatilsData.distributorInfo ? orderDeatilsData.distributorInfo.distributorCommission : '0.00' }}</h5>
        <h3>上级分销员</h3>
        <h5>{{ orderDeatilsData.distributionSuperiorInfo ? orderDeatilsData.distributionSuperiorInfo.name : '--' }}</h5>
        <h3>上级佣金</h3>
        <h5>￥{{ orderDeatilsData.distributionSuperiorInfo ? orderDeatilsData.distributionSuperiorInfo.distributorCommission : '0.00' }}</h5>
      </div>
    </div>
    <div v-if="orderDeatilsData.itemList && orderDeatilsData.orderType !=6" class="box">
      <div v-if="orderDeatilsData.itemList.length !=0">
        <div class="title">订单详情</div>
        <!-- <div class="subtitle">
          <img v-if="orderDeatilsData.memberType == 1" src="@/assets/images/crown.png" />
          <img v-else-if="orderDeatilsData.memberType == 2" src="@/assets/images/plante.png" />
          <span>本次开单{{ orderDeatilsData.memberType == 1 ? '使用会员权益' : orderDeatilsData.memberType == 2 ? '使用样子权益' : '没有使用权益' }}</span>
        </div> -->
        <el-table :data="orderDeatilsData.itemList" tooltip-effect="light">
          <el-table-column label="项目/产品/套餐" min-width="115px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.isGift===1" effect="light" placement="bottom">
                <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
                <span class="give-icon">赠</span>
              </el-tooltip>
              <el-tooltip v-if="scope.row.isGift===2" effect="light" placement="bottom">
                <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
                <span class="buygive-icon">买赠</span>
              </el-tooltip>
              <el-tooltip v-if="scope.row.isGift===3" effect="light" placement="bottom">
                <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
                <span class="fullgive-icon">满赠</span>
              </el-tooltip>
              <!-- <ActivityTwo v-if="scope.row.activityType" :type="scope.row.activityType"></ActivityTwo> -->
              <span>{{ scope.row.name || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="原价（元）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}</span>
              <el-tooltip v-if="scope.row.isUpdatePrice == 1" effect="light" placement="right">
                <div slot="content">已改价</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="折后价（元）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.isGift===1 || scope.row.isGift===2 || scope.row.isGift===3">0.00</span>
              <div v-else>
                <div v-if="orderDeatilsData.memberMsg ? (orderDeatilsData.memberMsg.wholesaleInfo && scope.row.isWholesale == 1) ? true : false : false" style="height: 28px;line-height: 28px;">
                  <span style="float: left;line-height: 28px;">{{ scope.row.discountMoney ? (scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
                  <el-popover placement="right" trigger="hover">
                    <div style="padding: 10px;font-size: 12px;">{{ orderDeatilsData.memberMsg ? orderDeatilsData.memberMsg.wholesaleInfo ? orderDeatilsData.memberMsg.wholesaleInfo.gradeName : '' : '' }}</div>
                    <img slot="reference" style="width: 28px;height: 28px;margin-left: 5px;" src="@/assets/images/goods.png" />
                  </el-popover>
                </div>
                <span v-else>{{ scope.row.discountMoney ? (scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="数量" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="小计" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-if="scope.row.isGift===1">0.00</div>
              <div v-else>
                <span v-if="scope.row.isGiftDeduct===1">0.00</span>
                <span v-else>{{ (scope.row.deductAmount == 0 || !scope.row.deductAmount) ? scope.row.resultPrice : (scope.row.resultPrice*1-scope.row.deductAmount*1).toFixed(2) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="优惠金额（元）" width="120px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-if="scope.row.isGift">--</div>
              <div v-else>
                <span>{{ scope.row.totalDiscountPrice }}</span><el-tooltip v-if="(scope.row.deductDtoList ? scope.row.deductDtoList.length > 0 ? true : false : false) || (scope.row.detailList ? scope.row.detailList.length > 0 ? true : false : false)" effect="light" placement="right">
                  <div slot="content">
                    <h5 v-for="(v,n) in scope.row.deductDtoList" :key="n">{{ v.isElectronicTicketDeduct == 1 ? '电子票划扣：-￥' : v.isGiftDeduct == 1 ? '赠品划扣：-￥' : '套餐划扣：-￥' }}{{ v.deductAmount }}</h5>
                    <h5 v-for="(v,n) in scope.row.detailList" v-show="v.type != 1 && v.type != 99" :key="n">{{ v.type == 2 ? '特价活动：-￥' : v.type == 3 ? '定时打折：-￥' : v.type == 4 ? '会员优惠：-￥' : v.type == 5 ? '改价优惠：-￥' : '' }}{{ ((scope.row.price*1-v.rightsPrice*1)*v.count).toFixed(2) }}</h5>
                  </div>
                  <i class="iconfont" style="font-size: 14px;color:#d3d3d3;margin-left: 5px;">&#xe71a;</i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="提成员工" min-width="95px">
            <template slot-scope="scope">
              <div v-if="scope.row.isGift">--</div>
              <div v-else>
                <el-tooltip v-if="scope.row.percentage4ServeList.length > 0 && scope.row.itemType == 0" class="item" effect="light" placement="right">
                  <div slot="content" style="display: flex;">
                    <p>{{ Lib.collectively() }}：</p>
                    <div style="flex: 1;">
                      <p v-for="(item,index) in scope.row.percentage4ServeList" :key="index" style="padding: 0 10px 0 0;">
                        <span>{{ item.isGuest == 1 ?'点客':'非点客' }}-{{ item.technicianName }}<br></span>
                      <!-- <span>{{item.technicianName}}({{ item.item4ServeList[0].price }}{{item.item4ServeList[0].percentageType == 1 ? '元' : '%'}})<br></span> -->
                      </p>
                    </div>
                  </div>
                  <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <span>{{ Lib.collectively() }}：</span>
                    <span v-for="(a,b) in scope.row.percentage4ServeList" :key="b">{{ a.isGuest == 1 ?'点客':'非点客' }}-{{ a.technicianName }}{{ scope.row.percentage4ServeList.length == (b+1) ? '' : ',' }}</span>
                  </p>
                </el-tooltip>
                <span v-else-if="scope.row.percentage4ServeList.length == 0 && scope.row.percentageSellServeList.length == 0 && scope.row.itemType == 0">--</span>
                <div v-if="scope.row.refundType != 1">
                  <el-tooltip v-if="scope.row.percentageSellServeList.length > 0" class="item" effect="light" placement="right">
                    <div slot="content" style="display: flex;">
                      <p>销售：</p>
                      <div style="flex: 1;">
                        <p v-for="(item,index) in scope.row.percentageSellServeList" :key="index" style="padding: 0 10px 0 0;">
                          <span>{{ item.technicianName }}<br></span>
                        <!-- <span>{{item.technicianName}}({{ item.percentageNumber }}{{item.percentageType == 1 ? '元' : '%'}})<br></span> -->
                        </p>
                      </div>
                    </div>
                    <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                      <span>销售：</span>
                      <span v-for="(c,d) in scope.row.percentageSellServeList" :key="d">{{ c.technicianName }}{{ scope.row.percentageSellServeList.length == (d+1) ? '' : ',' }}</span>
                    </p>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.percentageSellServeList.length == 0 && scope.row.itemType != 0" :disabled="orderDeatilsData.orderType == 3 ? (orderDeatilsData.percentageTechnicianName ? false : true) : (scope.row.percentageTechnicianName ? false : true)" class="item" effect="light" placement="right">
                    <div slot="content" style="display: flex;">
                      <p>{{ orderDeatilsData.orderType == 3 ? (orderDeatilsData.percentageTechnicianName ? ('销售：'+orderDeatilsData.percentageTechnicianName) : '--') : (scope.row.percentageTechnicianName ? ('销售：'+scope.row.percentageTechnicianName) : '--') }}</p>
                    </div>
                    <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                      <span>{{ orderDeatilsData.orderType == 3 ? (orderDeatilsData.percentageTechnicianName ? ('销售：'+orderDeatilsData.percentageTechnicianName) : '--') : (scope.row.percentageTechnicianName ? ('销售：'+scope.row.percentageTechnicianName) : '--') }}</span>
                    </p>
                  </el-tooltip>
                </div>
                <div v-else>--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="orderDeatilsData.orderType != 3 && orderDeatilsData.refundStatus" label="退款类型" width="120px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- 0:退金额,1:退次数,2:退货,3:退金额退货,4:退次数退货 -->
              <span v-if="scope.row.isGift">--</span>
              <span v-else>{{ scope.row.refundType === null ? '--' : scope.row.refundType == 1 ? '退次数' : scope.row.refundType == 2 ? '退货' : scope.row.refundType == 3 ? '退金额退货' : scope.row.refundType == 4 ? '退次数退货' : '退金额' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="orderDeatilsData.serviceFreesList" class="box">
      <div v-if="orderDeatilsData.serviceFreesList.length !=0" style="padding-bottom:30px;">
        <div class="title">赠送服务</div>
        <el-table :data="orderDeatilsData.serviceFreesList" tooltip-effect="light">
          <el-table-column prop="name" label="服务项目名称" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="validDateStr" label="有限期">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--5.10开房信息-->
    <div v-if="roomList.customInfoList" class="box">
      <div class="title">{{ getRoomType==1?'开房信息':getRoomType==2?'床位信息':'台位信息' }}</div>
      <div class="orderInfo">
        <h3>{{ roomList.infoType!=3?'预订时间':'预定时间' }}</h3>
        <h5>{{ roomList.createTime ? roomList.createTime.substring(0,16) : '--' }}</h5>
        <h3>使用时长</h3>
        <h5>{{ roomList.dateTime || '--' }}</h5>
        <h3>使用时间</h3>
        <h5>{{ roomList.beginTime || '--' }}</h5>
        <h3>离店时间</h3>
        <h5>{{ roomList.endTime || '--' }}</h5>
        <h3>{{ getRoomType==1?'房间详情':getRoomType==2?'床位详情':'台位详情' }}</h3>
        <h5 class="see" @click="roommentRecords()">查看详情</h5>
        <h3>状态</h3>
        <!-- "订单状态（1 锁定 2 预订 3 入住 5 已退房 6 过期 7 超时 8 取消） -->
        <h5 v-if="roomList.infoType===2">已预订</h5>
        <h5 v-if="roomList.infoType===3">已使用</h5>
        <h5 v-if="roomList.infoType===5">{{ getRoomType==1?'已退房':'已退位' }}</h5>
        <h5 v-if="roomList.infoType===6">已过期</h5>
        <h5 v-if="roomList.infoType===7">已超时</h5>
        <h5 v-if="roomList.infoType===8">已取消</h5>
        <h3>备注</h3>
        <h6>{{ roomList.remarks || '--' }}</h6>
      </div>
    </div>
    <!-- 订单信息 -->
    <div v-if="orderDeatilsData.dtoList==null && orderDeatilsData.orderType !=6&&orderDeatilsData.orderType !=5 " class="box">
      <div class="title">开单信息</div>
      <div class="orderInfo">
        <h3>开单时间</h3>
        <h4>{{ orderDeatilsData.createTime }}</h4>
        <h3>开单人员</h3>
        <h5>
          <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
            <div slot="content">
              <p>{{ orderDeatilsData.billingStaff || '--' }}</p>
            </div>
            <span class="commonTableShow" style="width: 140px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ orderDeatilsData.billingStaff || '--' }}</span>
          </el-tooltip>
        </h5>
        <h3>订单合计</h3>
        <h5>￥{{ orderDeatilsData.amount || '0.00' }}</h5>
        <h3>订单来源</h3>
        <h5>{{ orderDeatilsData.buySource == 0 ? '电脑端' : orderDeatilsData.buySource == 1 ? '粉丝端' : orderDeatilsData.buySource == 2 ? '店员APP' : 'Smartbox' }}</h5>
      </div>
      <div class="orderRemark">
        <h3>消费人数</h3>
        <h5>{{ orderDeatilsData.orderCustomer || '--' }}</h5>
        <h3 v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp')">手牌号码</h3>
        <el-tooltip v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp')&&orderDeatilsData.handCard" class="item" effect="light" placement="top">
          <div slot="content" style="font-size: 14px;color: #333;font-weight: 400;">{{ orderDeatilsData.handCard }}</div>
          <h5>{{ orderDeatilsData.handCard || '--' }}</h5>
        </el-tooltip>
        <h5 v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp') && !orderDeatilsData.handCard">{{ orderDeatilsData.handCard || '--' }}</h5>
        <h3>备注</h3>
        <h6>
          <span v-show="IsAq==0 ||orderDeatilsData.orderSignature">
            <el-popover v-if="orderDeatilsData.orderSignature" placement="right-start" trigger="hover">
              <img :src="orderDeatilsData.orderSignature" alt="">
              <span slot="reference" class="autograph autograph_G">已签名</span>
            </el-popover>
            <span v-else class="autograph autograph_D">未签名</span>
          </span>
          {{ orderDeatilsData.remark || '  无' }}
        </h6>
      </div>
    </div>
    <!--结算信息-->
    <div v-if="orderDeatilsData.orderType== 6&&orderDeatilsData.orderType != 5 &&orderDeatilsData.bookOrderMsgDTO && orderDeatilsData.bookOrderMsgDTO.bookPrice ==0" class="box">
      <div class="title">结算信息</div>
      <p>该项目不需要定金</p>
    </div>
    <!--结算信息-->
    <!-- <div v-else class="box"> -->
    <div v-if="orderDeatilsData.orderType!= 6&&orderDeatilsData.orderType != 5 && orderDeatilsData.orderStatus == 2" class="box">
      <div class="title">结算信息</div>
      <div v-if="orderDeatilsData.bookOrderMsgDTO &&orderDeatilsData.bookOrderMsgDTO.bookPrice >0">
        <p v-if="orderDeatilsData.bookOrderMsgDTO.refundPriceTime >0" style="margin:-10px 0 10px">距离预约时间{{ orderDeatilsData.bookOrderMsgDTO.refundPriceTime }}小时以内，不退回定金或划扣次数</p>
      </div>
      <div class="orderInfo">
        <div v-if="orderDeatilsData.orderType != 6">
          <h3>结算时间</h3>
          <h4 v-if="orderDeatilsData.payTime">{{ orderDeatilsData.payTime }}</h4>
          <h5 v-else>--</h5>
        </div>
        <div v-if="orderDeatilsData.initAmount >0&&orderDeatilsData.orderType != 6">
          <h3>消费总额</h3>
          <h5>￥{{ orderDeatilsData.initAmount || '0.00' }}</h5>
        </div>
        <div v-if="orderDeatilsData.orderType == 6&&orderDeatilsData.bookOrderMsgDTO && orderDeatilsData.bookOrderMsgDTO.bookPrice >0">
          <h3>预约定金</h3>
          <h4>￥{{ orderDeatilsData.bookOrderMsgDTO.bookPrice || '0.00' }}</h4>
        </div>
        <div v-if="orderDeatilsData.orderType != 2 && orderDeatilsData.orderType != 4 && totalDiscountMoney()">
          <h3>优惠金额</h3>
          <h5>
            -￥{{ totalDiscountMoney() || '0.00' }}
            <el-tooltip v-if="totalDiscountMoney()" effect="light" placement="right">
              <div slot="content">
                <h5 v-for="(v,n) in orderDeatilsData.discountDetailList" :key="n">{{ v.discountType }}：-￥{{ v.discountPrice }}</h5>
              </div>
              <i class="iconfont" style="font-size: 14px;color:#d3d3d3">&#xe71a;</i>
            </el-tooltip>
          </h5>
        </div>
        <div v-if="orderDeatilsData.deductAmount*1>0||orderDeatilsData.giftDeduct*1>0||orderDeatilsData.electronicTicketDeduct*1>0">
          <h3>划扣金额</h3>
          <h5>
            -￥{{ (orderDeatilsData.deductAmount*1+orderDeatilsData.giftDeduct*1+orderDeatilsData.electronicTicketDeduct*1).toFixed(2) || '--' }}
            <el-tooltip effect="light" placement="right">
              <div slot="content">
                <h5 v-if="orderDeatilsData.deductAmount*1 > 0">套餐划扣：-￥{{ orderDeatilsData.deductAmount ? (orderDeatilsData.deductAmount*1).toFixed(2) : '0.00' }}</h5>
                <h5 v-if="orderDeatilsData.giftDeduct*1 > 0">赠送划扣：-￥{{ orderDeatilsData.giftDeduct ? (orderDeatilsData.giftDeduct*1).toFixed(2) : '0.00' }}</h5>
                <h5 v-if="orderDeatilsData.electronicTicketDeduct*1 > 0">电子票划扣：-￥{{ orderDeatilsData.electronicTicketDeduct ? (orderDeatilsData.electronicTicketDeduct*1).toFixed(2) : '0.00' }}</h5>
              </div>
              <i class="iconfont" style="font-size: 14px;color:#d3d3d3">&#xe71a;</i>
            </el-tooltip>
          </h5>
        </div>
        <div v-if="(orderDeatilsData.balance !=0&& settlementCode == '部分支付') || settlementCode == '赊账'">
          <h3>应收金额</h3>
          <h5>{{ orderDeatilsData.shouldAmount != null ? ('￥'+(orderDeatilsData.shouldAmount*1).toFixed(2)) : '--' }}</h5>
        </div>
        <div v-show="settlementCode != '赊账' && settlementCode != '优惠全额抵扣' && settlementCode != '划扣'">
          <div v-if="orderDeatilsData.bookOrderMsgDTO &&orderDeatilsData.bookOrderMsgDTO.deductType ==1">
            <h3>实收金额</h3>
            <h5>{{ orderDeatilsData.orderStatus== 2 ?('￥'+orderDeatilsData.resultAmount) : '--' }}</h5>
          </div>
          <div v-else-if="orderDeatilsData.bookOrderMsgDTO &&orderDeatilsData.bookOrderMsgDTO.bookPrice>0 &&orderDeatilsData.bookOrderMsgDTO.buySource == 1
            &&orderDeatilsData.orderStatus == 1"
          >
            <h3>实收金额</h3>
            <h5>{{ ('￥'+(orderDeatilsData.bookOrderMsgDTO.bookPrice*1).toFixed(2)) }}(预收定金)</h5>
          </div>
          <div v-else-if="orderDeatilsData.resultAmount >0">
            <h3>实收金额</h3>
            <h5>{{ orderDeatilsData.resultAmount != null ? ('￥'+(orderDeatilsData.resultAmount*1).toFixed(2)) : '--' }}</h5>
          </div>
          <div v-else>
            <h3>实收金额</h3>
            <h5>--</h5>
          </div>
        </div>
        <div v-if="orderDeatilsData.orderType == 7&&orderDeatilsData.orderStatus ==1">
          <h3>结算方式</h3>
          <h5>--</h5>
        </div>
        <div v-if="orderDeatilsData.initAmount >0 &&orderDeatilsData.orderType != 6">
          <h3>结算方式</h3>
          <h5>{{ orderDeatilsData.orderStatus ==1?'--':settlementCode }}</h5>
        </div>
        <div v-show="settlementCode != '赊账' && settlementCode != '优惠全额抵扣' && settlementCode != '划扣'">
          <div v-if="( orderDeatilsData.orderType == 6 || orderDeatilsData.orderType == 7 )&&orderDeatilsData.partPayType !=1">
            <h3>支付方式</h3>
            <h5>{{ orderDeatilsData.payTypeName || '--' }}</h5>
          </div>
          <div v-else-if="orderDeatilsData.partPayType == 0 && orderDeatilsData.resultAmount > 0&&orderDeatilsData.orderType !=4 && (settlementCode != '赊账' || settlementCode == '入账') ">
            <h3>支付方式</h3>
            <h5>{{ orderDeatilsData.payTypeName || '--' }}</h5>
          </div>
          <div v-show="orderDeatilsData.orderType != 6 &&orderDeatilsData.partPayType ==1">
            <h3>支付方式</h3>
            <el-tooltip v-if="orderDeatilsData.orderStatus ==1" effect="light" placement="right" :disabled="tooltipStatus">
              <div slot="content">
                <h5>{{ orderDeatilsData.orderStatus ==1?'--':orderDeatilsData.payTypeName }}</h5>
              </div>
              <h5 @mouseover="tooltipStatus = Lib.textShow($event)">{{ orderDeatilsData.orderStatus ==1?'--':orderDeatilsData.payTypeName }}</h5>
            </el-tooltip>
            <h5 v-else @click="paymentRecords(orderDeatilsData.orderCode,orderDeatilsData.orderType)">
              <span style="cursor: pointer;color: #fd5c8c;">查看记录</span>
            </h5>
          </div>
        </div>
        <div v-if="settlementCode == '部分支付' &&orderDeatilsData.balance !=0">
          <h3>剩余款项</h3>
          <h5>{{ orderDeatilsData.balance ? ('￥'+(orderDeatilsData.balance*1).toFixed(2)) : '--' }}</h5>
        </div>
        <div v-if="orderDeatilsData.orderType != 6">
          <h3>结算人员</h3>
          <h5>{{ orderDeatilsData.orderStatus ==1 ?'--':orderDeatilsData.billingStaff }}</h5>
        </div>
      </div>
    </div>
    <div v-if="orderDeatilsData.refundMsg4OrderVo" class="box">
      <div class="title">退款信息</div>
      <div class="orderInfo">
        <h3>退款时间</h3>
        <h5>{{ orderDeatilsData.refundMsg4OrderVo.refundTime }}</h5>
        <h3>退款金额</h3>
        <h5>
          -￥{{ orderDeatilsData.refundMsg4OrderVo.amount || '0.00' }}
          <el-tooltip v-if="orderDeatilsData.refundMsg4OrderVo.amount" effect="light" placement="right">
            <div slot="content">
              <h5 v-for="(v,n) in orderDeatilsData.refundMsg4OrderVo.payItemList" :key="n">{{ v.payType == 1 ? '现金' : v.payType == 2 ? '银行卡' : v.payType == 3 ? '会员卡' : v.payType == 4 ? '扫码' : v.payType == 5 ? '赊账' : v.payType == 6 ? '魔盒' : v.payType == 7 ? '个人微信' : v.payType == 8 ? '个人支付宝' : v.payType == 9 ? '微信（官方）' : v.payType == 10 ? '支付宝（官方）' : v.payType == 11 ? '微信（通联）' : v.payType == 12 ? '支付宝（通联）' : v.payType == 13 ? '微信（翼支付）' : v.payType == 14 ? '支付宝（翼支付）' : v.payType == 15 ? '微信（合利宝）' : v.payType == 16 ? '支付宝（合利宝）' : v.payType == 17 ? '微信（收银宝）' : v.payType == 18 ? '支付宝（收银宝）' : '其他' }}：-￥{{ v.amount }}</h5>
            </div>
            <i class="iconfont" style="font-size: 14px;">&#xe71a;</i>
          </el-tooltip>
        </h5>
        <h3>退款发起人</h3>
        <h5>{{ orderDeatilsData.refundMsg4OrderVo.initiatorName || '--' }}</h5>
        <div v-if="orderDeatilsData.orderType !=6">
          <h3>退款授权人</h3>
          <h5>{{ orderDeatilsData.refundMsg4OrderVo.dutyName || '--' }}</h5>
        </div>
        <div v-if="orderDeatilsData.orderType != 6">
          <h3>退款记录</h3>
          <h5 @click="refundRecords(orderDeatilsData.orderId)">
            <span style="cursor: pointer;color: #fd5c8c;">查看记录</span>
          </h5>
        </div>
        <div v-if="orderDeatilsData.orderType == 6">
          <h3>其他信息</h3>
          <h5 @click="refundRecords(orderDeatilsData.orderId)">
            <h5 v-if="orderDeatilsData.refundMsg4OrderVo.productInCount || orderDeatilsData.refundMsg4OrderVo.deductRefundCount">{{ orderDeatilsData.refundMsg4OrderVo.productInCount ? ('已退还产品入库数量('+orderDeatilsData.refundMsg4OrderVo.productInCount+'次)') : '' }}{{ (orderDeatilsData.refundMsg4OrderVo.productInCount && orderDeatilsData.refundMsg4OrderVo.deductRefundCount) ? '，' : '' }}{{ orderDeatilsData.refundMsg4OrderVo.deductRefundCount ? ('已返还套餐划扣次数('+orderDeatilsData.refundMsg4OrderVo.deductRefundCount+'次)') : '' }}</h5>
            <h5 v-else>--</h5>
          </h5>
        </div>
        <div v-else>
          <h3>其他信息</h3>
          <h5 v-if="orderDeatilsData.refundMsg4OrderVo.productInCount || orderDeatilsData.refundMsg4OrderVo.deductRefundCount" style="width: 610px;">{{ orderDeatilsData.refundMsg4OrderVo.productInCount ? ('已退还产品入库数量('+orderDeatilsData.refundMsg4OrderVo.productInCount+'次)') : '' }}{{ (orderDeatilsData.refundMsg4OrderVo.productInCount && orderDeatilsData.refundMsg4OrderVo.deductRefundCount) ? '，' : '' }}{{ orderDeatilsData.refundMsg4OrderVo.deductRefundCount ? ('已返还套餐划扣次数('+orderDeatilsData.refundMsg4OrderVo.deductRefundCount+'次)') : '' }}</h5>
          <h5 v-else style="width: 610px;">--</h5>
        </div>
      </div>
    </div>
    <!-- <div style="float: right;margin: 0 0 0 10px;" v-if="(orderDeatilsData.newStatus == 2 ||orderDeatilsData.newStatus == 3) && (orderDeatilsData.refundStatus == 1 && orderDeatilsData.refundStatus == 2)">
            <el-button size="small" @click="cancelRefund">取消退款</el-button>
        </div> -->
    <!-- orderStatus：订单状态(1：待结算，2：已结算)；partPayType（0：不是部分支付订单，1：部分支付订单）；balance：剩余金额；refundStatus(1：退款中，2：退款失败，3：部分退款，4：全部退款) ；orderType-订单类型（1:服务订单 5：房间订单）

    -->
    <div v-if="((orderDeatilsData.orderStatus == 2 || (orderDeatilsData.partPayType == 1 && orderDeatilsData.balance > 0) ||
      orderDeatilsData.refundStatus != 0) && orderDeatilsData.orderType != 5 && orderDeatilsData.orderType != 6
      && orderDeatilsData.refundStatus != 4 && orderDeatilsData.allGiftOrderStatus != 1 && settlementCode != '优惠全额抵扣' && refundBtnStatus())
      || (settlementCode == '优惠全额抵扣' && (orderDeatilsData.deductAmount * 1 > 0))" style="float: right;margin: 0 0 0 10px;"
    >
      <el-button v-show="loading == false&&orderDeatilsData.refundStatus!=4" size="small" @click="refund(orderDeatilsData.orderType,orderDeatilsData.orderId)">退款</el-button>
    </div>

    <div v-if="(orderDeatilsData.orderStatus == 2 || orderDeatilsData.refundStatus != 0 )&& orderDeatilsData.orderType != 6&& orderDeatilsData.orderType != 5" style="float: right;height: 32px;line-height: 32px;display: flex;">
      <div v-if="isDesktop===0&&ishd==0">
        <i :class="refreshStatus ? 'el-icon-loading' : 'el-icon-refresh'" @click="getPrinterList"></i>
        <span>当前打印机设备号：</span>
        <el-dropdown v-if="printerId || printerName" trigger="click" style="margin-right: 10px;" @command="choosePrinter">
          <span class="el-dropdown-link">
            {{ printerName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu v-if="printerList.length > 0" slot="dropdown" size="medium" @click="choosePrinter">
            <el-dropdown-item v-for="(v,n) in printerList" :key="n" :command="v.id+','+v.printerName" :disabled="v.printerState == 0 ? true : false">{{ v.printerName }}{{ v.printerState == 0 ? '（不在线）' : '' }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <label v-else>
          <span class="theme-red">未连接</span>
          <span class="theme-blue" @click="jumpSetPrinter">前往设置</span>
        </label>
      </div>
      <el-button v-if="printerId" size="small" type="primary" @click="printOrder(1)">打印小票</el-button>
      <el-button v-if="orderDeatilsData.orderType == 1&&isDesktop===0&&ishd==0" size="small" type="primary" @click="aFourPrint(0)">PDF打印</el-button>
      <el-popover v-if="isDesktop===1||ishd==1" placement="bottom-start" trigger="hover">
        <div class="order_mode">
          <ul class="order_ul">
            <li v-if="orderDeatilsData.orderType == 1" @click="aFourPrint(0)">PDF打印</li>
            <li :class="active==1?'order_ul_active':''" @click="aFourPrint(1)">客户端打印<i class="order_ul_icon el-icon-arrow-right"></i></li>
          </ul>
          <div v-if="templateList.length>0" class="order_template">
            <div v-for="item in templateList" :key="item.id" :class="item.id === activeTow?'order_template_name_color order_template_name':'order_template_name'" @click="selectTemplateId(item)">{{ item.templateName }}</div>
          </div>
          <div v-else class="order_template">
            <div class="order_template_name">暂无模板</div>
          </div>
        </div>
        <el-button slot="reference" size="small" type="primary" style=" margin-left: 10px;">
          更多打印<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
      </el-popover>
      <!-- <el-button size="small" type="primary" @click="aFourPrint" v-if="orderDeatilsData.orderType == 1&&ishd==0">更多打印<i class="el-icon-arrow-down el-icon--right"></i></el-button> -->
    </div>
    <!--6.1需要修改-->
    <el-dialog title="退款" :visible.sync="refundDialog" :append-to-body="true" width="1000px">
      <div slot="title" class="header-title">
        <span style="font-size: 14px;font-weight: 600;">退款</span>
        <el-popover placement="right" width="500" trigger="hover">
          <div style="padding: 10px;">
            <p>1.退款页面不可修改员工业绩与提成，商家可在“员工业绩与提成”进行修改</p>
            <p>2.修改业绩提成后产生的退款提成将在本月进行扣除</p>
            <p>3.“销售达标提成”、“劳动达标提成”不可修改与扣除</p>
            <p>4.粉丝端预约定金，暂不支持线上退还</p>
          </div>
          <i slot="reference" style="color: #d2d2d2;font-size: 14px;" class="el-icon-warning"></i>
        </el-popover>
      </div>
      <div class="order-details">
        <!---6.1需要对接口-->
        <div v-if="refundData.vipCardMsg4RefundList.length>0" class="box">
          <div class="title" style="margin-bottom: 10px;">套餐概况</div>
          <el-table :data="refundData.vipCardMsg4RefundList" tooltip-effect="light">
            <el-table-column label="套餐名称" :show-overflow-tooltip="true" prop="vipCardName"></el-table-column>
            <el-table-column label="购买金额" :show-overflow-tooltip="true" prop="amount"></el-table-column>
            <el-table-column label="数量" :show-overflow-tooltip="true" prop="buyCount"></el-table-column>
            <el-table-column label="总次数" :show-overflow-tooltip="true" prop="discount">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.allCount?scope.row.allCount+'次':'-' }}===</span> -->
                <span>{{ scope.row.countLimitType===2?'无限次数':scope.row.countLimitType!==2?scope.row.allCount+'次':'-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="已使用" :show-overflow-tooltip="true" prop="discount">
              <template slot-scope="scope">
                <span>{{ scope.row.useCount?scope.row.useCount+'次':'-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="套餐权益" :show-overflow-tooltip="true" prop="discount">
              <template slot-scope="scope">
                <el-popover placement="bottom" trigger="click">
                  <div class="order-popover">
                    <p v-for="(item,index) in scope.row.vipCardItemList" :key="index">
                      <span :class="item.typeName=='项目'?'title' +' ' + 'backg-bule':item.typeName=='产品'?'title' +' ' + 'backg-gree':'title'">{{ item.typeName }}</span>
                      <span class="text mgl">{{ item.itemName }}</span>
                      <!-- <span class="text">{{ item.allCount?item.allCount:'0' }}次 已使用({{ item.useCount?item.useCount:'0' }})次</span> -->
                      <span class="text textright">{{ item.countLimitType==2?'无限次数': item.countLimitType==1?item.allCount+'次':item.countLimitType==3?'':'0次' }} 已使用({{ item.useCount?item.useCount:'0' }})次</span>
                    </p>
                    <!--可以删除 <p v-for="(item,index2) in arr2" :key="index2">
                      <span :class="index2===0?'title' +' ' + 'backg-bule':'title'">{{ index2===0?'项目':'' }}</span>
                      <span class="text mgl">{{ item.title }}</span>
                      <span class="text">{{ item.text }}</span>
                    </p>
                    <p v-for="(item,index3) in arr3" :key="index3">
                      <span :class="index3===0?'title' +' ' + 'backg-gree':'title'">{{ index2===0?'产品':'' }}</span>
                      <span class="text mgl">{{ item.title }}</span>
                      <span class="text">{{ item.text }}</span>
                    </p> -->
                  </div>
                  <el-button slot="reference" type="text">查看 </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="box">
          <div class="title" style="margin-bottom: 10px;">订单修改</div>
          <el-table :data="refundData.itemList" tooltip-effect="light">
            <el-table-column label="项目/产品/套餐" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.name || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="原价" width="90px" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="折后价" width="90px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.discountMoney ? (scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量" width="90px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-input v-if="scope.row.refundType == 2 || scope.row.refundType == 3 || scope.row.refundType == 4" v-model="scope.row.refundNum" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '').replace('.','')" @change="refundNumChange(scope.$index,scope.row.refundNum,scope.row.count,scope.row.refundCount)"></el-input>
                <span v-else>{{ scope.row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠价" width="110px" :show-overflow-tooltip="true">
              <template slot="header">
                <span>优惠价</span>
                <el-tooltip effect="light" placement="right">
                  <div slot="content">
                    <p>退款页面的优惠价为优惠券、积分、<br>粉币、整单改价的优惠平摊后的价格</p>
                  </div>
                  <i class="iconfont" style="font-size: 14px;color: #D2D2D2;">&#xe71a;</i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-input v-if="scope.row.refundType == 0 || scope.row.refundType == 3" v-model="scope.row.refundMoney" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" @change="refundMoneyChange(scope.$index,scope.row.refundMoney,scope.row.resultPayPrice)"></el-input>
                <span v-else>{{ scope.row.resultPayPrice || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="划扣次数" width="90px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-input v-if="scope.row.refundType == 1 || scope.row.refundType == 4" v-model="scope.row.refundCount" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '').replace('.','')" @change="refundGoodsChange(scope.$index,scope.row.refundCount,scope.row.deductCount)"></el-input>
                <span v-else>{{ scope.row.deductCount || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="划扣金额（元）" width="130px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ (scope.row.deductAmount && scope.row.deductAmount > 0) ? scope.row.deductAmount : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="退款类型" width="140px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-select v-model="scope.row.refundType" size="mini" placeholder="请选择" @change="totalRefundMoney">
                  <el-option value="9" label="无">无</el-option>
                  <el-option v-if="!scope.row.deductCount" value="0" label="退金额">退金额</el-option>
                  <el-option v-if="scope.row.itemType == 1" value="2" label="退货">退货</el-option>
                  <el-option v-if="scope.row.deductCount*1 == scope.row.count*1" value="1" label="退次数">退次数</el-option>
                  <el-option v-if="scope.row.itemType == 1 && !scope.row.deductCount" value="3" label="退金额退货">退金额退货</el-option>
                  <el-option v-if="scope.row.itemType == 1 && scope.row.deductCount" value="4" label="退次数退货">退次数退货</el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="orderDeatilsData.orderType != 4" class="box">
          <div class="title" style="margin-bottom: 10px;">收支明细</div>
          <div class="border">
            <p>
              <span>消费总额：</span>
              <label>￥{{ refundData.initAmount }}</label>
            </p>
            <p>
              <span>优惠金额：</span>
              <label>￥{{ refundData.discountAmount }}</label>
              <el-tooltip v-if="refundData.discountDetailList ? refundData.discountDetailList.length > 0 ? true : false : false" effect="light" placement="right">
                <div slot="content">
                  <p v-for="(v,n) in refundData.discountDetailList" :key="n">{{ v.discountType }}：-￥{{ v.discountPrice }}</p>
                  <!-- <p v-if="refundData.orderChangeMoney*1 > 0">整单改价：-￥{{ refundData.orderChangeMoney || '0.00' }}</p>
                  <p v-if="refundData.changeDiscountMoney*1 > 0">改价优惠：-￥{{ refundData.changeDiscountMoney || '0.00' }}</p>
                  <p v-if="refundData.deductAmount*1 > 0">套餐划扣：-￥{{ refundData.deductAmount || '0.00' }}</p>
                  <p v-if="refundData.integralMoney*1 > 0">积分抵扣：-￥{{ refundData.integralMoney || '0.00' }}</p>
                  <p v-if="refundData.fenbiMoney*1 > 0">粉币抵扣：-￥{{ refundData.fenbiMoney || '0.00' }}</p>
                  <p v-if="refundData.couponMoney*1 > 0">优惠券抵扣：-￥{{ refundData.couponMoney || '0.00' }}</p> -->
                </div>
                <i class="iconfont" style="padding-left: 5px;font-size: 14px;">&#xe71a;</i>
              </el-tooltip>
            </p>
            <p style="clear: both;display: flex;">
              <span>{{ settlementCode == '赊账' ? '赊账' : '实收金额' }}：</span>
              <label style="color: #FF4949 !important;font-weight: bold;">￥<b style="font-size: 18px;font-weight: bold;">{{ Lib.getValue(1,refundData.resultAmount) }}</b>{{ Lib.getValue(2,refundData.resultAmount) }}</label>
              <b v-if="settlementCode != '赊账' && settlementCode != '部分支付'">（{{ refundData.payTypeName }}）</b>
            </p>
            <p v-if="settlementCode == '赊账' || settlementCode == '部分支付'">
              <span>{{ settlementCode == '赊账' ? '未还金额：' : '剩余款项：' }}</span>
              <label>￥{{ settlementCode == '赊账' ? refundData.onAccountNoRefundAmount : refundData.balance }}</label>
              <b v-if="(settlementCode == '赊账' && !refundData.onAccountNoRefundAmount) || (settlementCode == '部分支付' && refundData.balance*1 == 0)" style="padding-left: 5px;color: #999;">(已还清)</b>
            </p>
            <p v-if="refundData.refundMsg4OrderVo">
              <span>已退款：</span>
              <label>￥{{ refundData.refundMsg4OrderVo ? refundData.refundMsg4OrderVo.amount ? refundData.refundMsg4OrderVo.amount : '0.00' : '0.00' }}</label>
            </p>
          </div>
        </div>
        <div class="box">
          <div class="title" style="margin-bottom: 10px;">
            <span>退款明细</span>
            <el-popover placement="right" trigger="hover">
              <div style="padding: 10px;max-width: 420px;">
                <p>1.已经使用过的积分、粉币、优惠券不能退还。</p>
                <p v-if="settlementCode == '部分支付'">2.部分支付的剩余款项大于退款合计时，退款直接在剩余款项扣除；剩余款项小于退款合计时，退款在剩余款项中扣除后，剩下的退款通过现金退回顾客</p>
                <p v-if="settlementCode == '赊账'">2.赊账的未还金额大于退款合计时，退款直接在未还金额扣除；未还金额小于退款合计时，退款在未还金额中扣除后，剩下的退款通过现金退回顾客</p>
              </div>
              <i slot="reference" style="color: #d2d2d2;font-size: 14px;" class="el-icon-warning"></i>
            </el-popover>
          </div>
          <div class="border">
            <p v-if="orderDeatilsData.orderType == 4" style="padding-left: 10px;">直接划扣订单不能退钱</p>
            <p v-if="settlementCode == '优惠全额抵扣'" style="padding-left: 10px;">优惠全额抵扣不能退金额</p>
            <p v-if="orderDeatilsData.orderType != 4 && settlementCode != '优惠全额抵扣'">
              <span style="width: 146px;">退款合计：</span>
              <label>￥{{ (refundTotal*1).toFixed(2) }}</label>
            </p>
            <div v-if="settlementCode == '赊账' || refundData.balance*1 >0">
              <p v-if="(settlementCode == '赊账' && !refundData.onAccountNoRefundAmount) ? false : true">
                <span style="width: 146px;">{{ settlementCode == '赊账' ? '未还金额扣除：' : '剩余款项扣除：' }}</span>
                <label>￥{{ settlementCode == '赊账' ? (refundData.onAccountNoRefundAmount > refundTotal) ? refundTotal : refundData.onAccountNoRefundAmount : (refundData.balance*1 > refundTotal) ? refundTotal : refundData.balance }}</label>
              </p>
              <p v-if="settlementCode == '赊账' ? (((refundTotal *1) > (refundData.onAccountNoRefundAmount*1)) && cashPayMoney > 0) : (((refundTotal *1) > (refundData.balance*1)) && cashPayMoney)">
                <span style="width: 146px;">现金退回：</span>
                <label>￥{{ settlementCode == '赊账' ? (((refundTotal *1) - (refundData.onAccountNoRefundAmount*1)).toFixed(2)) : (((refundTotal *1) - (refundData.balance*1)) > cashPayMoney ? cashPayMoney : ((refundTotal *1) - (refundData.balance*1))).toFixed(2) }}</label>
              </p>
              <p v-if="settlementCode == '赊账' ? (((refundTotal *1) > (refundData.onAccountNoRefundAmount*1)) && payMaxTwo) : (((refundTotal *1) - (refundData.balance*1))>cashPayMoney)">
                <span style="width: 146px;">会员卡退回：</span>
                <label>￥{{ settlementCode == '赊账' ? (((refundTotal *1) - (refundData.onAccountNoRefundAmount*1)).toFixed(2)) : (refundTotal *1 - refundData.balance*1-cashPayMoney).toFixed(2) }}</label>
              </p>
            </div>
            <div v-if="orderDeatilsData.orderType != 4 && settlementCode != '赊账' && refundData.balance*1 == 0 && settlementCode != '优惠全额抵扣'">
              <h4 v-for="(a,b) in payListData" :key="b">
                <span>{{ a.name }}退回：</span>
                <el-input v-model="a.money" class="qInput" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" :disabled="refundTotal*1 == 0" @input="distributeMoney(3,b)">
                  <template slot="prepend">￥</template>
                </el-input>
                <samp v-if="a.money > a.oldMoney">{{ a.name }}退回金额不可超过￥{{ a.oldMoney }}</samp>
              </h4>
              <h4 v-if="memberPayStatus == 2 || memberPayStatus == 3">
                <span>会员卡退回：</span>
                <el-input v-model="memberReturnVal" class="qInput" :disabled="memberPayStatus == 2 || refundTotal*1 == 0" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" @input="distributeMoney(1)">
                  <template slot="prepend">￥</template>
                </el-input>
                <samp v-if="memberReturnVal > payMaxTwo">会员卡退回金额不可超过￥{{ payMaxTwo }}</samp>
              </h4>
              <h4 v-if="memberPayStatus != 2">
                <span>现金退回：</span>
                <el-input v-model="cashReturnVal" class="qInput" :disabled="(payListData.length == 0 && memberPayStatus == 1) || refundTotal*1 == 0" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" @input="distributeMoney(2)">
                  <template slot="prepend">￥</template>
                </el-input>
              </h4>
            </div>
            <h5>
              <span>备注：</span>
              <label>
                <el-input v-model="refundRemark" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" placeholder="请填写退款备注（100字以内）" maxlength="100">
                </el-input>
              </label>
            </h5>
          </div>
        </div>
        <div style="float: right;">
          <!-- payMaxHandle() ||  -->
          <el-button type="primary" :disabled="(memberReturnVal*1 > payMaxTwo*1)" @click="comfirmRefund">确 定</el-button>
          <el-button @click="refundDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="退款" :visible.sync="quickRefundDialog" :append-to-body="true" width="1000px">
      <div class="quickRefund">
        <p>
          <span>实收金额：</span>
          <label>￥
            <samp>{{ Lib.getValue(1,refundData.payAmount) }}</samp>{{ Lib.getValue(2,refundData.payAmount) }}</label>
        </p>
        <h4>
          <span>现金退回：</span>
          <el-input v-model="quickRefundMoney" class="qInput" @change="quickChange(refundData.payAmount,quickRefundMoney)">
            <template slot="prepend">￥</template>
          </el-input>
        </h4>
        <h5>
          <span>备注：</span>
          <label>
            <el-input v-model="quickRefundRemark" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" placeholder="请填写退款备注（100字以内）" maxlength="100">
            </el-input>
          </label>
        </h5>
      </div>
      <div style="float: right;margin: 20px 0;">
        <el-button @click="quickRefundDialog = false">取 消</el-button>
        <el-button type="primary" @click="comfirmRefund">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="退款授权" :visible.sync="authorizeDialog" :append-to-body="true" width="360px">
      <div class="authorize">
        <p>现场扫码授权</p>
        <img :src="qrCodeUrl" />
        <p>请打开app扫码授权</p>
      </div>
    </el-dialog>

    <el-dialog title="取消退款" :visible.sync="cancelDialog" :append-to-body="true" width="580px">
      <div>确认进行取消退款操作？</div>
      <div style="float: right;margin: 20px 0 10px 0;">
        <el-button @click="cancelDialog = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelRefund">确 定</el-button>
      </div>
    </el-dialog>

    <yzPayDeatils @payRecord="getPayRecordData" />
    <yzRefundDeatils @refundRecord="getRefundRecordData" />
    <!-- <yzRoomDetails :show.sync="roomDetailsDialog" :detail-data="roomDetailsData" /> -->
    <yzRoomDetails :show.sync="roomDetailsDialog" :detail-data="roomDetailsData" :detail-data-arr="roomDetailsData.customInfoList" :get-room-type="getRoomType" />
  </div>
</template>
<script>
import {
  printOrder, getPrintSetList, obtainGainQRCode, getRefundPayStatus, getRefundPayAuthStatus, getRefundItemMsg, saveOrUpdateRefundMsg, getDragPrintTemplate, dragPrint
} from './api/index';
import yzPayDeatils from './template/payDetails';
import yzRefundDeatils from './template/refundDetails';
import yzRoomDetails from './template/roomDetails';

export default {
  components: {
    yzPayDeatils,
    yzRefundDeatils,
    yzRoomDetails
  },
  props: {
    orderDeatilsData: {
      type: Object,
      default: Object
    },
    orderDeatilsDialog: {
      type: Boolean,
      default: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 0, // 选中
      activeTow: 0,
      showTemplate: false, // 选择模板
      templateList: [], // 模板列表
      isDesktop: window.sessionStorage.isDesktop * 1, // 判断是否是客户端 0不是  1是-5.7添加
      ishd: window.sessionStorage.ishd ? 1 : 0, // 判断是否是HD  0不是  1是-5.7添加
      detailsDialog: false,
      tooltipStatus: false, // 文字过长的显示和隐藏
      printerList: [], // 打印机列表
      printerId: '', // 打印机ID
      printerName: '', // 打印机名称
      refreshStatus: false, // 刷新状态
      form: {
        useDetailsDialog: false,
        code: ''
      },
      refundForm: {
        refundDetailsDialog: false,
        id: ''
      },
      settlementCode: '', // 结算方式
      refundDialog: false, // 退款--弹窗
      quickRefundDialog: false, // 快捷退款--弹窗
      authorizeDialog: false, // 退款授权--弹窗
      cancelDialog: false, // 取消退款--弹窗
      wxReturnVal: '0.00', // 微信--通联回退金额
      memberReturnVal: '0.00', // 会员卡回退金额
      cashReturnVal: '0.00', // 现金回退金额
      roomList: [], // 房间列表
      customerList: [], // 查看房间详情
      roomDetailsDialog: false, // 展示房间详情
      roomDetailsData: {}, // 房间详情数据

      qrCodeUrl: '', // 退款授权二维码
      clearRefundPayAuthStatus: null, // 退款授权监听状态
      refundData: {
        vipCardMsg4RefundList: []
      },
      refundTotal: 0, // 退款合计金额
      refundRemark: '', // 退款备注

      quickRefundMoney: '', // 快捷收银现金回退金额
      quickRefundRemark: '', // 快捷收银退款备注
      memberPayStatus: 1, // 会员卡支付状态
      payMaxTwo: 0, // 会员卡退回最大值
      cashPayMoney: 0, // 现金退回最大值
      IsAq: window.sessionStorage.IsAq || 1, // 安全设置-客户端签名开关
      payListData: [], // 微信或支付宝支付的支付列表及金额

      // 5.9
      menusList: JSON.parse(sessionStorage.getItem('menusList')),
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)

      // 6.0假数据-后期需要修改
      arr1: [{
        id: 1, type: 1, title: '染发', text: '5次（已使用0次）'
      }, {
        id: 2, type: 1, title: '染发2', text: '5次（已使用10次）'
      }, {
        id: 3, type: 2, title: '飘柔200ml', text: '1次（已使用0次）'
      }],
      arr2: [
        {
          id: 1, type: 1, title: '染发', text: '5次（已使用0次）'
        }, {
          id: 2, type: 1, title: '染发2', text: '5次（已使用10次）'
        },
      ],
      arr3: [{
        id: 3, type: 2, title: '飘柔200ml', text: '1次（已使用0次）'
      }],
    };
  },
  watch: {
    loading(val) {
      if (val == false) {
        this.refundBtnStatus();
        this.getPrinterList();
      }
    },
    authorizeDialog(val) {
      if (!val) clearInterval(this.clearRefundPayAuthStatus);
    },
    refundDialog(val) {
      if (!val) {
        setTimeout(() => {
          this.memberPayStatus = 1;
          // this.settlementCode = ''
          this.reset();
          this.memberReturnVal = '0.00';
          this.cashReturnVal = '0.00';
          this.payMaxTwo = 0;
          this.cashPayMoney = 0;
          this.refundData = {
            vipCardMsg4RefundList: []
          };
          this.refundTotal = 0;
          this.refundRemark = '';
        }, 300);
      }
    }
  },
  activated() {
    this.getRoomType = window.sessionStorage.tidyStatus;// 设置的房态  1房间  2床位  3台位
    const vm = this;
    this.getPrinterList();
    vm.$emit('tansferDialog', vm.detailsDialog);
  },
  methods: {
    reset() {
      this.payListData.forEach((a) => {
        a.money = 0;
      });
    },
    // 获取针式打印(拖拽)设置的模板
    getTemplate() {
      const data = {
        orderId: this.orderDeatilsData.orderId,
        mainId: window.sessionStorage.mainId,
        orderType: this.orderDeatilsData.orderType,
      };
      getDragPrintTemplate(data).then((res) => {
        if (res.code === 0) {
          this.templateList = res.data;
          this.showTemplate = true;
        }
      });
    },
    // 选择模板id-打印
    selectTemplateId(data) {
      this.activeTow = data.id;
      const obj = {
        orderId: this.orderDeatilsData.orderId,
        mainId: window.sessionStorage.mainId,
        templateId: data.id,
        useScene: data.useScene,
        orderType: this.orderDeatilsData.orderType,
      };
      dragPrint(obj).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '打印成功',
            type: 'success'
          });
        }
      });
    },
    // 取消退款--弹窗
    cancelRefund() {
      this.cancelDialog = true;
    },
    // 确定取消退款
    comfirmCancelRefund() {

    },
    // 退款按钮显示和隐藏
    refundBtnStatus() {
      const newNum = 0;
      // 6.1去掉套餐限制-后期没问题可以删除
      // this.orderDeatilsData.itemList.forEach((a) => {
      //   if (a.itemType == 2) {
      //     newNum++;
      //   }
      // });
      if ((newNum == this.orderDeatilsData.itemList.length) && this.orderDeatilsData.itemList.length != 0) {
        return false;
      }
      return true;
    },
    // 退款
    refund(type, id) {
      if (type == 2) {
        this.quickRefundMoney = '';
        this.quickRefundRemark = '';
        this.quickRefundDialog = true;
      } else {
        this.refundTotal = 0;
        this.refundRemark = '';
        this.reset();
        this.memberReturnVal = '0.00';
        this.cashReturnVal = '0.00';
        this.refundDialog = true;
      }
      const data = {
        id,
        orderType: type
      };
      getRefundItemMsg(data).then((res) => {
        if (res.code == 0) {
          if (res.data.itemList) {
            res.data.itemList.forEach((a) => {
              a.refundType = '9';
              a.refundCount = '0';
              a.refundNum = '0';
              a.refundMoney = '0';
              if (res.data.orderType == 4) {
                a.deductAmount = a.resultPrice;
                a.deductCount = a.count;
              }
            });
          }
          this.memberPayStatus = 1;
          if (res.data.payTypeList) {
            const newArr = [];
            let cashTotal = 0;
            res.data.payTypeList.forEach((b) => {
              if (b.payType == 9) {
                newArr.push({
                  name: '微信-官方', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 10) {
                newArr.push({
                  name: '支付宝-官方', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 11) {
                newArr.push({
                  name: '微信-通联', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 12) {
                newArr.push({
                  name: '支付宝-通联', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 13) {
                newArr.push({
                  name: '微信-翼支付', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 14) {
                newArr.push({
                  name: '支付宝-翼支付', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 15) {
                newArr.push({
                  name: '微信-合利宝', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 16) {
                newArr.push({
                  name: '支付宝-合利宝', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 17) {
                newArr.push({
                  name: '微信-收银宝', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 18) {
                newArr.push({
                  name: '支付宝-收银宝', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 23) {
                newArr.push({
                  name: '货款余额', money: 0, oldMoney: b.money * 1, originOrderCode: b.originOrderCode
                });
              } else if (b.payType == 3) {
                if (res.data.payTypeList.length == 1) {
                  this.memberPayStatus = 2;
                } else {
                  this.memberPayStatus = 3;
                }
                this.payMaxTwo = b.money * 1;
              }
              if (b.payType != 3 && b.payType != 5) {
                cashTotal += b.money * 1;
              }
            });
            this.payListData = newArr;
            this.cashPayMoney = cashTotal;
          }
          this.refundData = res.data;
        }
      });
    },
    quickChange(old, edit) {
      if (edit * 1 > old * 1) {
        this.quickRefundMoney = (old * 1).toFixed(2);
      }
    },
    // 确认退款--提交数据
    authRefundSuccess() {
      const vm = this;
      const arr = [];
      let data = {};
      let payArr = [];
      if (vm.refundData.itemList) {
        vm.refundData.itemList.forEach((a) => {
          if (a.refundType != '9') { // 有选退款类型的数据--进行数据重组
            const obj = {};
            obj.afterAmount = a.refundMoney;
            obj.amount = (a.refundType == 0 || a.refundType == 3) ? (a.resultPayPrice * 1 - a.refundMoney * 1) : 0;
            if (a.refundType == 2 || a.refundType == 3 || a.refundType == 4) {
              obj.goodCount = (a.count * 1 - a.refundNum * 1).toFixed(0);
            } else {
              obj.goodCount = 0;
            }
            if (a.refundType == 1 || a.refundType == 4) {
              obj.count = (a.count * 1 - a.refundCount * 1).toFixed(0);
            } else if (a.refundType == 0 || a.refundType == 3) {
              obj.count = a.count;
            } else {
              obj.count = 0;
            }
            // if (a.deductType == 1) {
            //     obj.count = (a.count * 1 - a.refundCount * 1).toFixed(0)
            //     obj.goodCount = (a.count * 1 - a.refundNum * 1).toFixed(0)
            // } else {
            //     obj.count = 0
            //     obj.goodCount = (a.count * 1 - a.refundNum * 1).toFixed(0)
            // }
            obj.deductType = a.deductType;
            obj.itemId = a.itemId;
            obj.itemType = a.itemType;
            obj.orderId = vm.refundData.orderId;
            obj.orderItemId = a.orderItemId;
            obj.refundType = a.refundType;
            arr.push(obj);
          }
        });
      }
      if (vm.refundData.orderType == 2) {
        data = {
          amount: vm.quickRefundMoney,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: 2,
          payItemList: [
            {
              amount: vm.quickRefundMoney,
              payType: 1,
            }
          ],
          refundItemList: null,
          remark: vm.quickRefundRemark
        };
      } else if (vm.refundData.orderType == 4) {
        data = {
          amount: 0,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: 4,
          payItemList: [
            {
              amount: 0,
              payType: 0,
            }
          ],
          refundItemList: arr,
          remark: vm.refundRemark
        };
      } else if (vm.settlementCode == '赊账') {
        payArr = [];
        if (vm.refundData.onAccountNoRefundAmount) {
          if (vm.refundData.onAccountNoRefundAmount * 1 >= vm.refundTotal * 1) {
            payArr.push({
              amount: vm.refundTotal,
              payType: 21
            });
          }
        } else if (vm.payMaxTwo && vm.cashPayMoney) {
          if (vm.refundTotal > vm.cashPayMoney) {
            payArr.push({
              amount: vm.cashPayMoney,
              payType: 1
            }, {
              amount: (vm.refundTotal * 1 - vm.cashPayMoney).toFixed(2),
              payType: 3
            });
          } else {
            payArr.push({
              amount: vm.cashPayMoney,
              payType: 1
            });
          }
        } else {
          payArr.push({
            amount: vm.refundTotal,
            payType: vm.cashPayMoney ? 1 : 3
          });
        }
        data = {
          amount: vm.refundTotal,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: payArr,
          refundItemList: arr,
          remark: vm.refundRemark
        };
      } else if (vm.refundData.balance * 1 > 0) {
        payArr = [];
        if (((vm.refundTotal * 1) - (vm.refundData.balance * 1)) > vm.cashPayMoney) {
          payArr.push({
            amount: vm.cashPayMoney,
            payType: 1
          }, {
            amount: (vm.refundTotal * 1 - vm.refundData.balance * 1 - vm.cashPayMoney).toFixed(2),
            payType: 3
          }, {
            amount: vm.refundData.balance,
            payType: 20
          });
        } else if ((vm.refundTotal * 1) > (vm.refundData.balance * 1)) {
          payArr.push({
            amount: (vm.refundTotal * 1 - vm.refundData.balance * 1).toFixed(2),
            payType: 1
          }, {
            amount: vm.refundData.balance,
            payType: 20
          });
        } else {
          payArr.push({
            amount: vm.refundTotal,
            payType: 20
          });
        }
        data = {
          amount: vm.refundTotal,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: payArr,
          refundItemList: arr,
          remark: vm.refundRemark
        };
      } else if (vm.settlementCode == '优惠全额抵扣') {
        data = {
          amount: 0,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: [
            {
              amount: 0,
              payType: 0,
            }
          ],
          refundItemList: arr,
          remark: vm.refundRemark
        };
      } else {
        payArr = [];
        vm.payListData.forEach((a) => {
          payArr.push({
            amount: a.money,
            payType: (a.name == '微信-官方') ? 9 : (a.name == '支付宝-官方') ? 10 : (a.name == '微信-通联') ? 11 : (a.name == '支付宝-通联') ? 12 : (a.name == '微信-翼支付') ? 13 : (a.name == '支付宝-翼支付') ? 14 : (a.name == '微信-合利宝') ? 15 : (a.name == '支付宝-合利宝') ? 16 : (a.name == '微信-收银宝') ? 17 : (a.name == '支付宝-收银宝') ? 18 : 23,
            originOrderCode: a.originOrderCode
          });
        });
        if (vm.memberPayStatus != 1) {
          payArr.push({
            amount: vm.memberReturnVal,
            payType: 3
          });
        }
        if (vm.memberPayStatus != 2) {
          payArr.push({
            amount: vm.cashReturnVal,
            payType: 1
          });
        }
        data = {
          amount: vm.refundTotal,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: payArr,
          refundItemList: arr,
          remark: vm.refundRemark
        };
      }
      saveOrUpdateRefundMsg(data).then((res) => {
        if (res.code == 0) {
          vm.quickRefundDialog = false;
          vm.authorizeDialog = false;
          vm.refundDialog = false;
          vm.$emit('tansferDialog', false);
          vm.$emit('newGetListData', '');
          vm.refundTotal = 0;
          vm.quickRefundRemark = '';
          vm.refundRemark = '';
          vm.reset();
          vm.memberReturnVal = 0;
          vm.cashReturnVal = 0;
          vm.$message({ type: 'success', message: '操作成功' });
          vm.getRefundPayStatus();
        }
      });
    },
    // 修改退款分配金额
    distributeMoney(val, index) {
      const vm = this;
      if (vm.payListData.length > 0 && vm.memberPayStatus == 3) {
        if (val == 1) {
          if (vm.memberReturnVal * 1 > vm.payMaxTwo * 1) {
            vm.$message(`会员卡退回金额不可超过￥${vm.payMaxTwo * 1 > vm.refundTotal * 1 ? vm.refundTotal : vm.payMaxTwo}`);
            let newTotal = 0;
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1;
            });
            const r1 = (vm.refundTotal * 1 > (vm.payMaxTwo * 1 + newTotal)) ? vm.payMaxTwo * 1 : vm.refundTotal * 1;
            if (r1 == vm.refundTotal * 1) {
              vm.reset();
              vm.memberReturnVal = r1;
              vm.cashReturnVal = (vm.refundTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
            } else {
              vm.memberReturnVal = r1;
              vm.cashReturnVal = (Math.abs(vm.refundTotal * 1 - newTotal - vm.memberReturnVal * 1) * 1).toFixed(2);
            }
          } else {
            let newTotal = 0;
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1;
            });
            const r1 = (vm.refundTotal * 1 >= (vm.memberReturnVal * 1 + newTotal)) ? vm.memberReturnVal * 1 : vm.refundTotal * 1;
            if (r1 == vm.refundTotal * 1 && vm.memberReturnVal * 1 != vm.payMaxTwo * 1) {
              vm.reset();
              vm.memberReturnVal = r1;
              vm.cashReturnVal = (vm.refundTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
            } else {
              // vm.memberReturnVal = r1;
              vm.cashReturnVal = (Math.abs(vm.refundTotal * 1 - newTotal - vm.memberReturnVal * 1) * 1).toFixed(2);
            }
          }
        } else if (val == 2) {
          if (vm.cashReturnVal * 1 > vm.refundTotal * 1) {
            vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
            vm.memberReturnVal = 0;
            vm.reset();
          } else {
            let newTotal = 0;
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1;
            });
            const r1 = (vm.refundTotal * 1 >= (vm.cashReturnVal * 1 + newTotal)) ? vm.cashReturnVal * 1 : vm.refundTotal * 1;
            if (r1 == vm.refundTotal * 1) {
              vm.reset();
              vm.cashReturnVal = r1;
              vm.memberReturnVal = (vm.refundTotal * 1 - vm.cashReturnVal * 1).toFixed(2);
            } else {
              // vm.cashReturnVal = r1;
              vm.memberReturnVal = (vm.refundTotal * 1 - newTotal - vm.cashReturnVal * 1).toFixed(2);
            }
          }
        } else if (val == 3) {
          if (vm.refundTotal * 1 > vm.payListData[index].money * 1) {
            if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
              vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.payListData[index].oldMoney}`);
              vm.payListData[index].money = vm.payListData[index].oldMoney;
              let newTotal = 0;
              vm.payListData.forEach((c) => {
                newTotal += c.money * 1;
              });
              vm.memberReturnVal = 0;
              vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
            } else {
              let newTotal = 0;
              vm.payListData.forEach((c) => {
                newTotal += c.money * 1;
              });
              vm.memberReturnVal = 0;
              vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
            }
          } else if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
            vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal}`);
            vm.payListData[index].money = (vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal);
            let newTotal = 0;
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1;
            });
            vm.memberReturnVal = 0;
            vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
          } else {
            vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.refundTotal}`);
            vm.payListData[index].money = vm.refundTotal;
            let newTotal = 0;
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1;
            });
            vm.memberReturnVal = 0;
            vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
          }
        } else {
          vm.reset();
          vm.memberReturnVal = 0;
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
        }
      } else if (vm.memberPayStatus == 3 && vm.payListData.length == 0) {
        if (val == 1) {
          if (vm.memberReturnVal * 1 > vm.refundTotal * 1) {
            vm.memberReturnVal = (vm.refundTotal * 1).toFixed(2);
            vm.reset();
            vm.cashReturnVal = 0;
          } else {
            vm.reset();
            vm.cashReturnVal = (vm.refundTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
          }
        } else if (val == 2) {
          if (vm.cashReturnVal * 1 > vm.refundTotal * 1) {
            vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
            vm.memberReturnVal = 0;
            vm.reset();
          } else {
            vm.reset();
            vm.memberReturnVal = (vm.refundTotal * 1 - vm.cashReturnVal * 1).toFixed(2);
          }
        } else {
          vm.reset();
          vm.memberReturnVal = 0;
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
        }
      } else if (vm.memberPayStatus == 1 && vm.payListData.length > 0) {
        if (val == 3) {
          vm.refundCone(index);
        } else if (val == 2) {
          if (vm.cashReturnVal * 1 > vm.refundTotal * 1) {
            vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
            vm.memberReturnVal = 0;
            vm.reset();
          } else {
            vm.reset();
            vm.memberReturnVal = (vm.refundTotal * 1 - vm.cashReturnVal * 1).toFixed(2);
          }
        } else {
          vm.reset();
          vm.memberReturnVal = 0;
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
        }
      } else if (vm.memberPayStatus == 2) {
        if (vm.refundData.balance * 1 > 0) {
          vm.reset();
          vm.memberReturnVal = 0;
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
        } else {
          vm.reset();
          vm.memberReturnVal = (vm.refundTotal * 1).toFixed(2);
          vm.cashReturnVal = 0;
        }
      } else {
        vm.reset();
        vm.memberReturnVal = 0;
        vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2);
      }
    },
    // 退款步骤简化一
    refundCone(index) {
      const vm = this;
      if (vm.refundTotal * 1 > vm.payListData[index].money * 1) {
        if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
          vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.payListData[index].oldMoney}`);
          vm.payListData[index].money = vm.payListData[index].oldMoney;
          vm.refundCtwo(index);
        } else {
          vm.refundCtwo(index);
        }
      } else if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
        vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal}`);
        vm.payListData[index].money = (vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal);
        vm.refundCtwo(index);
      } else {
        vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.refundTotal}`);
        vm.payListData[index].money = vm.refundTotal;
        vm.refundCtwo(index);
      }
    },
    // 退款步骤简化二
    refundCtwo(index) {
      const vm = this;
      let newTotal = 0;
      vm.payListData.forEach((c) => {
        newTotal += c.money * 1;
      });
      if (newTotal > vm.refundTotal * 1) {
        vm.reset();
        vm.payListData[index].money = (vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal);
        vm.memberReturnVal = 0;
        vm.cashReturnVal = (vm.refundTotal * 1 - vm.payListData[index].money * 1 - vm.memberReturnVal * 1).toFixed(2);
      } else {
        vm.memberReturnVal = 0;
        vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2);
      }
    },
    // 修改退款--退货
    refundNumChange(index, num, count) {
      if ((num * 1) > (count * 1)) {
        this.refundData.itemList[index].refundNum = count;
      }
      this.totalRefundMoney();
    },
    // 修改退款--退次数
    refundGoodsChange(index, num, count) {
      if ((num * 1) > (count * 1)) {
        this.refundData.itemList[index].refundCount = count;
      }
      this.totalRefundMoney();
    },
    // 修改退款优惠价--退款
    refundMoneyChange(index, num, count) {
      if ((num * 1) > (count * 1)) {
        this.refundData.itemList[index].refundMoney = count;
      }
      this.totalRefundMoney();
    },
    // 计算退款合计金额
    totalRefundMoney() {
      let total = 0;
      this.refundData.itemList.forEach((a) => {
        if (a.refundType == '0' || a.refundType == '3') {
          total = (total * 1 + (a.resultPayPrice - a.refundMoney)).toFixed(2);
        }
      });
      this.refundTotal = total;
      this.distributeMoney();
    },
    payMaxHandle() {
      let pnum = 0;
      this.payListData.forEach((a) => {
        if (a.oldMoney * 1 >= a.money * 1) {
          pnum++;
        }
      });
      return (this.payListData.length == pnum);
    },
    // 确认退款
    comfirmRefund() {
      // || this.payMaxHandle()
      if ((this.memberReturnVal > this.payMaxTwo)) {
        this.$message('请填写正确的退回金额');
        return;
      }
      let returnStatus = 1;
      if (this.refundData.itemList) {
        this.refundData.itemList.forEach((a) => {
          if (a.refundType != '9') {
            returnStatus = 2;
          }
        });
      }
      if (returnStatus == 1 && this.refundData.orderType != 2) {
        this.$message('请选择退款类型');
        return;
      }
      if (this.refundData.refundAuth == 1) {
        this.authRefundSuccess();
        return;
      }
      this.authorizeDialog = true;
      const data = {
        orderCode: this.refundData.orderCode
      };
      obtainGainQRCode(data).then((res) => {
        if (res.code == 0) {
          this.qrCodeUrl = this.Lib.A() + res.data.url;
          this.getRefundPayAuthStatus();
        }
      });
    },
    // 获得退款状态
    getRefundPayStatus() {
      const data = {
        orderCode: this.refundData.orderCode
      };
      getRefundPayStatus(data).then((res) => {
        if (res.code == 0) {
          console.log(res);
        }
      });
    },
    // 获得退款授权状态
    getRefundPayAuthStatus() {
      const vm = this;
      vm.clearRefundPayAuthStatus = setInterval(() => {
        const data = {
          orderCode: vm.refundData.orderCode
        };
        getRefundPayAuthStatus(data).then((res) => {
          if (res.code == 0) {
            // 0:退款授权中，1：退款授权成功，2：退款授权失败
            if (res.data.status == 0) {
              // vm.$message('退款授权中')
              // vm.authRefundSuccess()
              // clearInterval(vm.clearRefundPayAuthStatus)
            } else if (res.data.status == 1) {
              vm.$message({ message: '退款授权成功', type: 'success' });
              clearInterval(vm.clearRefundPayAuthStatus);
              vm.authRefundSuccess();
            } else if (res.data.status == 2) {
              vm.$message.error('退款授权失败');
              clearInterval(vm.clearRefundPayAuthStatus);
            }
          } else {
            clearInterval(vm.clearRefundPayAuthStatus);
          }
        });
      }, 1000);
    },
    // 赋值组件数据----付款记录
    getPayRecordData(list) {
      this.form = list;
    },
    // 付款记录弹窗
    paymentRecords(code, type) {
      this.form.useDetailsDialog = true;
      this.form.code = code;
      this.form.orderType = type == 3 ? 1 : 0;
    },
    // 赋值组件数据----退款记录
    getRefundRecordData(list) {
      this.refundForm = list;
    },
    // 退款记录弹窗
    refundRecords(id) {
      this.refundForm.refundDetailsDialog = true;
      this.refundForm.id = id;
    },
    // 赋值组件数据----查看房间
    getRoomRecordData(list) {
      this.room = list;
    },
    // 查看房间弹框
    roommentRecords() {
      if (this.orderDeatilsData.orderRoomDetail) {
        // this.roomDetailsData = this.orderDeatilsData.dtoList;
        this.roomDetailsData = this.orderDeatilsData.orderRoomDetail;
      } else {
        this.roomDetailsData = this.orderDeatilsData.roomDetailOrder;
      }
      this.roomDetailsDialog = true;
    },
    // 选择打印机
    choosePrinter(val) {
      this.printerId = val.split(',')[0];
      this.printerName = val.split(',')[1];
    },
    // 获取打印机列表
    getPrinterList() {
      //  房间赋值
      this.roomList = {};
      // 5.10前
      // if (this.orderDeatilsData.dtoList) {
      //   this.roomList = this.orderDeatilsData.dtoList;
      //   this.orderDeatilsData.dtoList.customerList.forEach((list) => {
      //     list.orderCode = this.orderDeatilsData.dtoList.orderCode;
      //   });
      //   this.customerList = this.orderDeatilsData.dtoList.customerList;
      // } else if (this.orderDeatilsData.roomDetailOrder) {
      //   this.roomList = this.orderDeatilsData.roomDetailOrder;
      //   this.customerList = this.orderDeatilsData.roomDetailOrder.customerList ? this.orderDeatilsData.roomDetailOrder.customerList : [];
      // }
      // 5.10
      if (this.orderDeatilsData.orderRoomDetail) {
        this.orderDeatilsData.orderRoomDetail.customInfoList.forEach((list) => {
          list.orderCode = this.orderDeatilsData.orderRoomDetail.orderCode;
        });
        this.roomList = this.orderDeatilsData.orderRoomDetail; // 5.10
        this.customerList = this.orderDeatilsData.orderRoomDetail.customInfoList;
      } else if (this.orderDeatilsData.roomDetailOrder) {
        this.roomList = this.orderDeatilsData.roomDetailOrder;
        this.customerList = this.orderDeatilsData.roomDetailOrder.customerList ? this.orderDeatilsData.roomDetailOrder.customerList : [];
      }
      let countTotal = 0;
      let deductCountTotal = 0;
      let countStatus;
      this.orderDeatilsData.itemList.forEach((a) => {
        countTotal += (a.count ? (a.count * 1) : 0);
        deductCountTotal += (a.deductCount ? (a.deductCount * 1) : 0);
      });
      if (countTotal == deductCountTotal) {
        countStatus = 1;
      } else {
        countStatus = 2;
      }
      this.settlementCode = this.orderDeatilsData.partPayType == 1 ? '部分支付'
        : this.orderDeatilsData.payTypeName == '赊账' ? '赊账'
          : this.orderDeatilsData.resultAmount == 0 ? (countStatus == 1 || this.orderDeatilsData.orderType == 4) ? '划扣' : (this.orderDeatilsData.deductAmount || this.orderDeatilsData.discountAmount || this.orderDeatilsData.fenbiMoney || this.orderDeatilsData.integralMoney || this.orderDeatilsData.couponMoney) ? '优惠全额抵扣' : '入账' : '入账';
      this.refreshStatus = true;
      const data = {
        printType: this.orderDeatilsData.orderType == 2 ? 31 : 30
      };
      getPrintSetList(data).then((res) => {
        if (res && res.code == 0) {
          this.refreshStatus = false;
          this.printerList = res.data;
          let pNum = 'null';
          if (res.data) {
            res.data.forEach((v, n) => {
              if (v.printerState == 1) {
                pNum = (pNum == 'null' ? n : n > pNum ? pNum : n);
              }
            });
            if (pNum == 'null') {
              this.printerId = '';
              this.printerName = '暂无可用设备';
            } else {
              this.printerId = res.data[pNum].id;
              this.printerName = res.data[pNum].printerName;
            }
          }
        } else {
          this.refreshStatus = true;
        }
      });
    },
    // 返回图片
    returnImg(orderDeatilsData) {
      if (orderDeatilsData.refundStatus == 0) {
        return orderDeatilsData.partPayType == 1 && orderDeatilsData.balance > 0 ? 'static/images/order/order_03.png'
          : orderDeatilsData.orderStatus == 2 ? 'static/images/order/order_01.png'
            : orderDeatilsData.orderStatus == 1 ? 'static/images/order/order_02.png'
              : 'static/images/order/order_01.png';
      }
      return orderDeatilsData.refundStatus == 1 ? 'static/images/order/order_06.png'
        : orderDeatilsData.refundStatus == 2 ? 'static/images/order/order_07.png'
          : orderDeatilsData.refundStatus == 3 ? 'static/images/order/order_04.png'
            : 'static/images/order/order_05.png';
    },
    // 返回房间详情图片
    roomImg(val) {
      return val == 3 ? 'static/images/order/order_09.png'
        : val == 5 ? 'static/images/order/order_08.png'
          : 'static/images/order/order_09.png';
    },
    // 顾客详情
    customerDetails(phone) {
      this.$emit('tansferDialog', false);
      window.sessionStorage.customerPhone = phone;
      this.$router.push({
        name: 'customer-details'
      });
    },
    // A4打印type-0是PDF打印.1是更多打印
    aFourPrint(type) {
      if (type == 0) {
        window.open(`${this.Lib.A()}/export/pdf/pur/getCustomerOrderMsg?orderId=${this.orderDeatilsData.orderId}`);
        // window.location.href = `${this.Lib.A()}/export/pdf/pur/getCustomerOrderMsg?orderId=${this.orderDeatilsData.orderId}`;
      } if (type == 1) {
        this.active = 1;
        this.getTemplate();
      }
    },
    // 前往后台设置打印机
    jumpSetPrinter() {
      window.open(window.sessionStorage.setUrl4Print);
    },
    // 打印小票
    printOrder(num) {
      const data = {
        orderId: this.orderDeatilsData.orderId,
        mainId: window.sessionStorage.mainId,
        printType: this.orderDeatilsData.orderType, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
        printId: this.printerId,
        isManual: num ? 1 : 0
      };
      printOrder(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 2000,
            onClose: () => {
              this.detailsDialog = false;
            }
          });
        }
      });
    },
    totalDiscountMoney() {
      let total = 0;
      if (this.orderDeatilsData.discountDetailList) {
        this.orderDeatilsData.discountDetailList.forEach((a) => {
          total += a.discountPrice * 1;
        });
      }
      return total;
    }
  }
};
</script>
<style lang="less" scoped>
.order_ul_active {
  color: #09d8fd !important;
}
.order_template_name_color {
  color: #09d8fd !important;
}
.el-table td,
.el-table th {
  padding: 7px 0;
}
.memberInfo::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.memberInfo::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.memberInfo::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.memberInfo::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.memberInfo {
  height: 80px;
  padding: 0 0 10px 0;
  width: 940px;
  overflow-x: visible;
  overflow-y: hidden;
  .srcoll {
    padding: 10px 30px;
    background-color: #f5f7fa;
    width: max-content;
    min-width: 880px;
    height: 60px;
    overflow: hidden;
    .payStatus {
      float: right;
      margin-top: -24px;
      margin-right: -25px;
      img {
        width: 60px;
        height: 60px;
        display: block;
        float: right;
        padding-right: 10px;
      }
      p {
        height: 30px;
        line-height: 30px;
        padding-right: 10px;
        font-size: 14px;
        color: #fd5c8c;
        cursor: pointer;
        float: right;
        clear: both;
      }
    }
    .i_one {
      float: left;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-radius: 50%;
      background-color: #fff;
      margin-right: 20px;
      i {
        color: #999;
        font-size: 28px;
      }
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        float: left;
      }
    }
    .li {
      float: left;
      padding: 8px 30px 8px 0;
      h5 {
        img {
          width: 20px;
          margin: 12px 9px 12px 0;
          float: left;
        }
        font-size: 14px;
        color: #333;
        height: 44px;
        line-height: 44px;
        max-width: 240px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        font-size: 14px;
        color: #333;
        height: 22px;
        line-height: 22px;
        span {
          float: right;
          font-size: 12px;
          background-color: #ffe9ee;
          color: #fd5c8c;
          height: 19px;
          line-height: 19px;
          border-radius: 8px;
          margin-left: 5px;
          padding: 0 5px 0 23px;
          i {
            position: relative;
            display: block;
            float: left;
            font-size: 12px;
            margin: -2px 0 0 -25px;
            background-color: #ffe9ee;
            text-align: center;
            width: 23px;
            height: 23px;
            line-height: 23px;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
.orderRemark {
  width: 940px;
  border-bottom: 1px solid #e6ebf5;
  display: flex;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    width: 89px;
    text-align: center;
    font-size: 14px;
    background-color: #f5f7fa;
    color: #333;
    float: left;
    border-right: 1px solid #e6ebf5;
  }
  h5 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    width: 139px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
  }

  h6 {
    flex: 1;
    padding: 10px 0;
    line-height: 26px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    word-wrap: break-word;
  }
}
.orderInfo {
  width: 940px;
  border-top: 1px solid #e6ebf5;
  display: table;
  .remarks{
    width: calc(100% - 100px)!important;
  }
  h2 {
    width: 140px;
    height: 32px;
    line-height: 16px;
    padding: 7px 0 7px 5px;
    font-size: 13px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
  }
  h3 {
    width: 89px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    background-color: #f5f7fa;
    color: #333;
    float: left;
    border-right: 1px solid #e6ebf5;
    border-bottom: 1px solid #e6ebf5;
  }
  h4 {
    width: 139px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
  }
  h5 {
    width: 139px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #e6ebf5;
  }
  h6 {
    width: 375px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.authorize {
  clear: both;
  margin-bottom: 30px;
  p {
    height: 16px;
    line-height: 16px;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
  img {
    display: block;
    width: 170px;
    height: 170px;
    margin: 0 auto;
  }
}
.quickRefund {
  clear: both;
  p {
    height: 35px;
    line-height: 33px;
    font-size: 14px;
    color: #333;

    span {
      float: left;
      width: 70px;
      text-align: right;
    }

    label {
      float: left;
      font-weight: bold;
      padding-left: 10px;
      samp {
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  h4 {
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    color: #333;

    span {
      float: left;
      width: 70px;
      text-align: right;
    }

    .qInput {
      float: left;
      padding-left: 10px;
      width: 220px;
      margin-top: 10px;
    }
  }

  h5 {
    padding: 10px 0;
    height: 54px;
    line-height: 27px;
    font-size: 14px;
    color: #333;

    span {
      float: left;
      width: 70px;
      text-align: right;
    }

    label {
      float: left;
      width: 420px;
      padding-left: 10px;
    }
  }
}
.order-details .border p label {
  color: #333 !important;
}
.autograph {
  width: 65px;
  height: 22px;
  border-radius: 5px;
  float: right;
  font-size: 12px;
  text-align: center;
  line-height: 22px;
  float: left;
  margin-right: 10px;
}
.autograph_D {
  border: 1px solid #e5e5e5;
  background-color: #f7f8fa;
  color: #999;
}
.autograph_G {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
// 打印
.order_mode {
  display: none;
  display: flex;
}
.order_ul {
  list-style-type: none;
  cursor: pointer;
  // padding:0 20px;
}
.order_ul li {
  width: 120px;
  text-align: left;
  font-size: 14px;
  color: #333333;
  padding: 13px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.order_ul_icon {
  font-size: 12px;
  color: #bcc1ce;
  text-align: right;
}
.order_template {
  list-style-type: none;
  cursor: pointer;
  border-left: 1px solid #e6ebf5;
  height: 140px;
  overflow: auto;
}
.order_template_name {
  text-align: left;
  font-size: 14px;
  color: #333333;
  padding: 13px 20px;
  min-width: 120px;
}
.order-details{
  width: 100%;
  }

.order-popover{
  padding:10px;
  min-width: 400px;
  // height: 300px;
  p{
    width: 100%;
    color:#6CC3F5FF;
    height: 28px;
    line-height: 28px;
    span{
      // vertical-align: top;
    }
    .title{
      width:28px;
      height:17px;
      text-align: center;
      font-size: 12px;
      line-height: 17px;
      border-radius: 4px;
      display: inline-block;
      margin-right: 7px;
      vertical-align: top;
      margin-top: 4px;
    }
    .text{
      font-size: 13px;
      color: #5A5E66;
      display: inline-block;
      // width: 130px;
    }
    .backg-bule{
      background: #DCF6FF;
      border: 1px solid #C1E4FB;
      color:#6CC3F5FF;
    }
    .backg-gree{
      background: #F0F9EB;
      border: 1px solid #E1F3D8;
      color:#67C23AFF;
    }
    .mgl{
      // width: 200px;
      // width: calc(100% - 167px);
      width: calc(100% - 60%);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .textright{
      // width: 130px;
      width: 40%;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>

<style>
.el-dialog__body {
  overflow-x: visible !important;
}
.order-details .el-loading-spinner {
  background-position-y: 50%;
  top: 0;
  padding-top: 0;
}
</style>
